import React from 'react';
import classNames from 'classnames';
import { LoadingSpinner } from './LoadingSpinner';
import { indexOf, map } from 'lodash';
import i18n from '../../utils/i18n';

// Stable keys (never translated) — used for localStorage and Redux state
const COLUMN_KEYS = [
  'id',              // 0
  'group',           // 1
  'cohort',          // 2
  'adult',           // 3
  'age-range',       // 4
  'locale',          // 5
  'created-at',      // 6
  'last-app-touch',  // 7
  'last-activity',   // 8
  'total-plays',     // 9
  'plays-during-interval',      // 10
  'total-free-plays',           // 11
  'free-plays-during-interval', // 12
  'total-photos',               // 13
  'photos-during-interval',     // 14
  'cards-liked',                // 15
  'cards-not-liked',            // 16
  'cards-too-hard',             // 17
  'cards-too-easy',             // 18
  'cards-just-right',           // 19
  'most-recent-asq',            // 20
  'last-message-from-family',   // 21
  'last-message-to-family',     // 22
];

const getAccountPlayersColumnTitles = () => [
  i18n.t('tableHelpers.columns.id'),
  i18n.t('tableHelpers.columns.group'),
  i18n.t('tableHelpers.columns.cohort'),
  i18n.t('tableHelpers.columns.adult'),
  i18n.t('tableHelpers.columns.ageRange'),
  i18n.t('tableHelpers.columns.locale'),
  i18n.t('tableHelpers.columns.createdAt'),
  i18n.t('tableHelpers.columns.lastAppTouch'),
  i18n.t('tableHelpers.columns.lastActivity'),
  i18n.t('tableHelpers.columns.totalPlays'),
  i18n.t('tableHelpers.columns.playsDuringInterval'),
  i18n.t('tableHelpers.columns.totalFreePlays'),
  i18n.t('tableHelpers.columns.freePlaysDuringInterval'),
  i18n.t('tableHelpers.columns.totalPhotos'),
  i18n.t('tableHelpers.columns.photosDuringInterval'),
  i18n.t('tableHelpers.columns.cardsLiked'),
  i18n.t('tableHelpers.columns.cardsNotLiked'),
  i18n.t('tableHelpers.columns.cardsTooHard'),
  i18n.t('tableHelpers.columns.cardsTooEasy'),
  i18n.t('tableHelpers.columns.cardsJustRight'),
  i18n.t('tableHelpers.columns.mostRecentAsq'),
  i18n.t('tableHelpers.columns.lastMessageFromFamily'),
  i18n.t('tableHelpers.columns.lastMessageToFamily'),
];

export const accountPlayersColumnsKeys = () => COLUMN_KEYS;

export const accountPlayersColumnsOptions = () => (
  map(COLUMN_KEYS, (key, idx) => ({ value: key, label: getAccountPlayersColumnTitles()[idx] }))
);

export const apColumn = (idx, titles = getAccountPlayersColumnTitles()) => titles[idx];

export const isColumnOn = (c, options) => indexOf(options, COLUMN_KEYS[c]) !== -1;

export const tableSpinner = () => {
  return (
    <div className='o-rtable__row o-rtable__row--note' key={0}>
      <div className="o-rtable__cell">
        <LoadingSpinner />
      </div>
    </div>
  );
}

export const tableSpinnerDefault = (colSpan) => {
  return (
    <tr key={0} className='cs-bg--light'>
      <td colSpan={colSpan} className='text-center'>
        <LoadingSpinner />
      </td>
    </tr>
  );
}

export const tableNoResults = () => {
  return (
    <div className="o-rtable__row text-center o-rtable__row--note" key={0}>
      <div className="o-rtable__cell u-paddding-top--base u-padding-bottom--base">
        {i18n.t('errors.noResults')}
      </div>
    </div>
  )
}

export const tableNoResultsDefault = (colSpan) => {
  return (
    <tr key={0} className='cs-bg--light'>
      <td colSpan={colSpan} className={colSpan < 10 ? 'text-center' : 'u-padding-left--base'}>
        {i18n.t('errors.noResults')}
      </td>
    </tr>
  )
}

export const clsHeaderIcon = (c, meta) => {
  const order = meta.order || 'asc';
  return classNames(
    { 'fa fa-sort o-table-header--icon cs-txt--sp-hr': meta.sort !== c,
      [`fa fa-sort-${order} o-table-header--icon`]: meta.sort === c,
    }
  );
}

export const tableHeaderSort = (key, meta, headers, onSortChange) => {
  return (
    <th data-sort={key} onClick={onSortChange}>
      <span data-sort={key} className='o-table-header--sort'>
        {headers[key]}<i data-sort={key} className={clsHeaderIcon(key, meta)}></i>
      </span>
    </th>
  )
}

export const tableHeaderSortIdx = (idx, meta, headers, onSortChange, titles = getAccountPlayersColumnTitles()) => {
  const key = headers[idx];
  return (
    <th data-sort={key} onClick={onSortChange}>
      <span data-sort={key} className='o-table-header--sort'>
        {apColumn(idx, titles)}<i data-sort={key} className={clsHeaderIcon(key, meta)}></i>
      </span>
    </th>
  )
}
